/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface HubbleCompaniesServiceUpdateUserData
 */
export interface HubbleCompaniesServiceUpdateUserData {
  /**
   *
   * @type {string}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  phoneNumber: string;
  /**
   *
   * @type {string}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  phoneNumberExtension?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  accountingNotificationsEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  allShipmentNotificationsEnabled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  deliveryNotificationsOnlyEnabled: boolean;
  /**
   *
   * @type {string}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  branchId?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof HubbleCompaniesServiceUpdateUserData
   */
  allowedToSwitchToLinkedCompanies: boolean;
}

/**
 * Check if a given object implements the HubbleCompaniesServiceUpdateUserData interface.
 */
export function instanceOfHubbleCompaniesServiceUpdateUserData(
  value: object,
): value is HubbleCompaniesServiceUpdateUserData {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("phoneNumber" in value) || value["phoneNumber"] === undefined)
    return false;
  if (
    !("accountingNotificationsEnabled" in value) ||
    value["accountingNotificationsEnabled"] === undefined
  )
    return false;
  if (
    !("allShipmentNotificationsEnabled" in value) ||
    value["allShipmentNotificationsEnabled"] === undefined
  )
    return false;
  if (
    !("deliveryNotificationsOnlyEnabled" in value) ||
    value["deliveryNotificationsOnlyEnabled"] === undefined
  )
    return false;
  if (
    !("allowedToSwitchToLinkedCompanies" in value) ||
    value["allowedToSwitchToLinkedCompanies"] === undefined
  )
    return false;
  return true;
}

export function HubbleCompaniesServiceUpdateUserDataFromJSON(
  json: any,
): HubbleCompaniesServiceUpdateUserData {
  return HubbleCompaniesServiceUpdateUserDataFromJSONTyped(json, false);
}

export function HubbleCompaniesServiceUpdateUserDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HubbleCompaniesServiceUpdateUserData {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    email: json["email"],
    phoneNumber: json["phoneNumber"],
    phoneNumberExtension:
      json["phoneNumberExtension"] == null
        ? undefined
        : json["phoneNumberExtension"],
    accountingNotificationsEnabled: json["accountingNotificationsEnabled"],
    allShipmentNotificationsEnabled: json["allShipmentNotificationsEnabled"],
    deliveryNotificationsOnlyEnabled: json["deliveryNotificationsOnlyEnabled"],
    branchId: json["branchId"] == null ? undefined : json["branchId"],
    allowedToSwitchToLinkedCompanies: json["allowedToSwitchToLinkedCompanies"],
  };
}

export function HubbleCompaniesServiceUpdateUserDataToJSON(
  json: any,
): HubbleCompaniesServiceUpdateUserData {
  return HubbleCompaniesServiceUpdateUserDataToJSONTyped(json, false);
}

export function HubbleCompaniesServiceUpdateUserDataToJSONTyped(
  value?: HubbleCompaniesServiceUpdateUserData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    email: value["email"],
    phoneNumber: value["phoneNumber"],
    phoneNumberExtension: value["phoneNumberExtension"],
    accountingNotificationsEnabled: value["accountingNotificationsEnabled"],
    allShipmentNotificationsEnabled: value["allShipmentNotificationsEnabled"],
    deliveryNotificationsOnlyEnabled: value["deliveryNotificationsOnlyEnabled"],
    branchId: value["branchId"],
    allowedToSwitchToLinkedCompanies: value["allowedToSwitchToLinkedCompanies"],
  };
}
